module.exports = __webpack_public_path__ + "static/media/easy.b8d8cb98.png";